import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme, type ThemePreference } from '../context/ThemeContext';

export const themeLabelKeys: Record<ThemePreference, string> = {
  light: 'settings.themeLight',
  'graphite-green': 'studio.theme.dark',
};

/** Shared by mobile settings and the desktop appearance menu. */
export function ThemePicker({ onSelect }: { onSelect?: () => void }) {
  const { t } = useTranslation();
  const { preference, setPreference } = useTheme();
  return (
    <fieldset className="theme-picker">
      <legend className="sr-only">{t('settings.appearance')}</legend>
      {(Object.keys(themeLabelKeys) as ThemePreference[]).map((value) => (
        <label key={value} className={`theme-picker__option${preference === value ? ' is-selected' : ''}`}>
          <span className={`theme-picker__swatch theme-picker__swatch--${value}`} aria-hidden="true"><i /></span>
          <span className="theme-picker__text">
            <strong>{t(themeLabelKeys[value])}</strong>
            {value === 'graphite-green' && <small>{t('studio.theme.darkHint')}</small>}
          </span>
          <input type="radio" name="app-theme" value={value} checked={preference === value}
            onChange={() => { setPreference(value); onSelect?.(); }} />
        </label>
      ))}
    </fieldset>
  );
}
